<template>
    <v-row no-gutters>
        <template>
            <div class="p-3">
                <!--                 
                <v-card class="mb-3" style="background-color: #f3f6f9;" elevation="0">
                    <v-container>
                        <div class="text-caption pb-1 indigo--text text--darken-4">
                            Filter
                        </div>
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-select small-chips dense class="pb-0" :items="selectOptions.roles" v-model="status"
                                    label="Berdasarkan status" @change="onChangeStatus($event)" solo></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-select small-chips dense class="pb-0" :items="selectOptions.roles" v-model="status"
                                    label="Berdasarkan status" @change="onChangeStatus($event)" solo></v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                -->
                <v-card elevation="1">
                    <v-card-title>
                        <v-row>
                            <v-col md="4" sm="12">
                                <v-text-field v-model="search" @keyup="onKeyup($event)" append-icon="mdi-magnify"
                                    label="Cari" single-line hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="users" item-key="name" :search="search" :loading="isLoading"
                        loading-text="Mengambil data... Mohon tunggu" :server-items-length="count"
                        @pagination="onChangePagination($event)">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Rekapitulasi dosen</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <!-- <v-btn outlined @click="fetchDataAndExportToExcel()" color="primary" dark class="mb-2 mr-2">
                                    XLSX
                                </v-btn> -->
                            </v-toolbar>
                        </template>
                        <template v-slot:item.bidang_keilmuan="{ item }">
                            <div v-if="item.bidang_keilmuan && item.bidang_keilmuan.length">
                                <div v-for="bk in item.bidang_keilmuan" :key="bk.id">
                                    {{ bk.name }}
                                </div>
                            </div>
                            <div v-else>-</div>
                        </template>
                        <template v-slot:item.diakui_count="{ item }">
                           <a @click="onShowModalList('total bimbingan', item)">{{ item.diakui_count }}</a>
                        </template>
                        <template v-slot:item.aktif_count="{ item }">
                           <a @click="onShowModalList('total bimbingan aktif', item)">{{ item.aktif_count }}</a>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon color="dark" class="mr-2" @click="editItem(item)">
                                mdi-eye
                            </v-icon>
                            <!-- <v-icon color="dark" @click="deleteItem(item)">
                                    mdi-delete
                                </v-icon> -->
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">
                                Mulai ulang
                            </v-btn>
                        </template>

                    </v-data-table>
                </v-card>
            </div>
        </template>
        <v-dialog
      v-model="dialogList"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title>List mahasiswa {{ selectedDataDialogList ?selectedDataDialogList.type : ''  }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-card flat class="grey lighten-4">
                <v-card-text>
                    <tr>
                        <td>Nama dosen</td>
                        <td>&ensp;:&emsp;</td>
                        <td>{{ selectedDataDialogList ? selectedDataDialogList.name : '' }}</td>
                    </tr>
                    <tr>
                        <td>NIK dosen</td>
                        <td>&ensp;:&emsp;</td>
                        <td>{{ selectedDataDialogList ? selectedDataDialogList.no_induk : '' }}</td>
                    </tr>
                </v-card-text>
            </v-card>
        </v-card-text>
        <v-card-text style="height: 300px;">
          <ol v-if="selectedDataDialogList && selectedDataDialogList.type == 'total bimbingan'">
            <li v-for="mhs in selectedDataDialogList.kp_pembimbings">
                {{ mhs.kp.users.name || '-'}} -  {{ mhs.kp.users.no_induk || '-'}} -  {{ mhs.status || '-'}} ( {{ mhs.kp.level_aprovals.status_aprovals.nama_status || ''}})
            </li>
          </ol>
          <ol v-if="selectedDataDialogList && selectedDataDialogList.type == 'total bimbingan aktif'">
            <li v-for="mhs in selectedDataDialogList.kp_pembimbingan">
                {{ mhs.kp.users.name || '-'}} -  {{ mhs.kp.users.no_induk || '-'}} -  {{ mhs.status || '-'}}  ( {{ mhs.kp.level_aprovals.status_aprovals.nama_status || ''}})
            </li>
          </ol>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="dialogList = false"
          >
            Tutup
          </v-btn>
        
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-row>
</template>
<script>
import * as XLSX from 'xlsx';
export default {
    data: () => ({
        selectOptions: {
            status: []
        },
        name: '',
        role_id: [],
        isLoading: false,
        status: '',
        kd_status: '',
        users: [],
        count: 10,
        limit: 10,
        offset: 0,
        search: '',
        dialogImport: false,
        dialogList: false,
        dialog: false,
        dialogDelete: false,
        headers: [],
        selectedDataDialogList: null,
    }),
    created() {
        console.log(localStorage.getItem("isAuth", true));
        this.getStatusData();
        this.setHeaders();
    },
    methods: {
        setHeaders() {
            if (this.$isFTSP) {
                this.headers = [
                    {
                        text: 'Nama',
                        align: 'start',
                        value: 'name',
                    },
                    {
                        text: 'No Induk',
                        value: 'no_induk',
                    },
                    {
                        text: 'Bidang keilmuan',
                        value: 'bidang_keilmuan',
                    },
                    { 
                        text: 'Total Bimbingan', 
                        value: 'diakui_count' 
                    },
                    { 
                        text: 'Bimbingan Aktif ', 
                        value: 'aktif_count' 
                    },
                ]

                return
            }

            if (this.$isFTI) {
                this.headers = [
                    {
                        text: 'Nama',
                        align: 'start',
                        value: 'name',
                    },
                    {
                        text: 'No Induk',
                        value: 'no_induk',
                    },
                    { 
                        text: 'Total Bimbingan', 
                        value: 'diakui_count' 
                    },
                    { 
                        text: 'Bimbingan Aktif ', 
                        value: 'aktif_count' 
                    },
                    // { text: 'Actions', value: 'actions', sortable: false },
                ]

                return
            }

            this.headers = [
                {
                    text: 'Nama',
                    align: 'start',
                    value: 'name',
                },
                {
                    text: 'No Induk',
                    value: 'no_induk',
                },
                { text: 'Total Bimbingan', value: 'diakui_count' },
                { text: 'Bimbingan Aktif ', value: 'aktif_count' },
                // { text: 'Actions', value: 'actions', sortable: false },
            ]
        }, 

        errorToast() {
            this.$emit("toast", "error", 'Maaf, fitur ini belum tersedia');
            this.dialogImport = false;
        },
        onChangeStatus(event) {
            this.kd_status = event;
            this.getData();
        },
        onChangePagination(event) {
            this.limit = event.itemsPerPage;
            this.offset = event.itemsPerPage * (event.page - 1);
            this.getData();
        },
        getStatusData() {
            this.isLoading = true;
            this.axios.get("/api/setting/roles").then((res) => {
                // this.selectOptions.roles = res.data.data ?? [];
                this.selectOptions.status.unshift({
                    text: 'Semua otoritas',
                    value: '',
                })
                this.selectOptions.status.push({
                    text: 'Tidak memiliki otoritas',
                    value: -1,
                })
            }).finally(() => this.isLoading = false);
        },
        onKeyup(event) {
            if (event.keyCode == 13) {
                this.getData();
            }
        },
        onShowModalList(type, data){
            this.selectedDataDialogList = data;
            this.selectedDataDialogList.type = type;
            this.dialogList = true;
        },
        async fetchDataAndExportToExcel() {
            try {
                const params = {
                    keyword: this.search,
                    status_pengajuan: this.status_pengajuan
                }
                const response = await this.axios.get('/api/rekap/dosen', { params: params })

                const items = response.data.data.map((el, idx) => {
                    return {
                        no: idx + 1,
                        nama: el.name,
                        nip: el.no_induk,
                        email: el.email,
                        total_bimbingan: el.diakui_count,
                        bimbingan_aktif: el.aktif_count,
                    }
                });

                const wscols = [
                    // A-E
                    { wch: 5 }, { wch: 30 }, { wch: 12 }, { wch: 25 }, { wch: 25 },
                    // F-J
                    { wch: 25 }, { wch: 12 }, { wch: 18 }, { wch: 20 }, { wch: 18 },
                    // K-0
                    { wch: 16 }, { wch: 22 }, { wch: 12 }, { wch: 12 }, { wch: 22 },
                    // P-T
                    { wch: 12 }, { wch: 16 }, { wch: 16 }, { wch: 12 }, { wch: 20 },
                    // U-Y
                    { wch: 18 }, { wch: 16 }, { wch: 16 }, { wch: 20 }, { wch: 20 },
                    // Z - AD
                    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 22 },
                    // AE - AI
                    { wch: 26 }, { wch: 22 }, { wch: 30 }, { wch: 12 }, { wch: 12 },
                    // AJ - AN
                    { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
                    // AO - AS
                    { wch: 12 }, { wch: 28 }, { wch: 36 }, { wch: 36 }, { wch: 34 },
                    // AT - AX
                    { wch: 38 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 28 },
                    // AY - BC
                    { wch: 18 }, { wch: 24 }, { wch: 24 }, { wch: 32 }, { wch: 28 },
                    // BD - BH
                    { wch: 22 }, { wch: 28 }, { wch: 28 }, { wch: 28 }, { wch: 28 },
                    // BI - BM
                    { wch: 20 }, { wch: 26 }, { wch: 26 }, { wch: 32 }, { wch: 26 },
                    // BN - BR
                    { wch: 36 }, { wch: 36 }, { wch: 30 }, { wch: 26 }, { wch: 36 },
                    // BS - BW
                    { wch: 18 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 },
                    // BX
                    { wch: 40 }
                ];

                const ws = XLSX.utils.json_to_sheet(items);
                ws['!cols'] = wscols;


                const wb = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(wb, ws, "Penjaluran");

                XLSX.writeFile(wb, `Rekap dosen ${this.$dates.now()}.xlsx`);
            } catch (error) {
                console.error("There was an error fetching the data: ", error);
            }
        },
        getData() {
            const params = {
                kd_status: this.kd_status,
                limit: this.limit,
                offset: this.offset,
                keyword: this.search
            };
            this.isLoading = true;
            this.axios.get("/api/rekap/dosen", { params: params }).then((res) => {
                this.users = res.data.data ?? [];
                this.count = res.data.count;
            }).finally(() => this.isLoading = false);
        },
        initialize() {
            this.getData();
        },
    },
}
</script>